(() => {
  if (customElements.get("media-horizontal-scroll")) {
    return;
  }

  class MediaHorizontalScroll extends HTMLElement {
    constructor() {
      super();
      this.selector = {
        section: 'js-media-horizontal-scroll',
        list: '.js-media-horizontal-scroll .media-horizontal-scroll__inner'
      };

      gsap.registerPlugin(ScrollTrigger)
      this.animateHorizontalScroll();
    }

    animateHorizontalScroll() {
      const horizontalScroll = document.querySelector(this.selector.list);

      function getHorizontalScrollAmount() {
        return -(horizontalScroll.scrollWidth - window.innerWidth);
      }

      const horizontalScrollAnimation = gsap.to(horizontalScroll, {
        x: getHorizontalScrollAmount,
        duration: 3,
        ease: 'none',
      });

      ScrollTrigger.create({
        trigger: horizontalScroll,
        start: 'top 15%',
        end: () => `+=${getHorizontalScrollAmount() * -1}`,
        pin: true,
        animation: horizontalScrollAnimation,
        scrub: 1,
        invalidateOnRefresh: true,
      });

      let resizeTimeout;
      const resizeObserver = new ResizeObserver(() => {
        clearTimeout(resizeTimeout);

        resizeTimeout = setTimeout(() => {
          ScrollTrigger.refresh(true);
        }, 300);
      });

      resizeObserver.observe(document.body);
    }
  }

  customElements.define("media-horizontal-scroll", MediaHorizontalScroll);
})();
